import React from "react";

import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import useStyles from "./Footer.styles";
import BrandLogo from "../../container/SportsBookNode/BrandLogo";
import { BRANDNAME } from "../../utils/constants";

export default function SbFooter() {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <div className={classes.sbFooterContainer}>
      <Grid className={classes.footerCopyrightSection}>
        <Grid className={classes.footerCopyrightLeft}>
          <BrandLogo />
          <Typography>
            {" "}
            {t("FOOTER.COPYRIGHT_MSG_START") +
              BRANDNAME +
              t("FOOTER.COPYRIGHT_MSG_END")}
          </Typography>
        </Grid>
        {/* <Link to="#" className={classes.privacy}>
          {t("FOOTER.PRIVACY_POLICY_MSG")}
        </Link> */}
      </Grid>
    </div>
  );
}
